import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { useSidebarStore } from '@/stores/sidebar.store'
import { useIsMobile } from '@/hooks/use-mobile'
import { useCurrentPhase } from '@/hooks/useCurrentPhase'
import { TooltipProvider } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import { PhaseFlow } from '@/components/PhaseFlow'
import { PHASES } from '@/pages/Dashboard'
import { AIChatBubble } from '@/components/ai/AIChatBubble'

export function MainLayout() {
  const { isCollapsed } = useSidebarStore()
  const isMobile = useIsMobile()
  const currentPhase = useCurrentPhase()

  return (
    <TooltipProvider delayDuration={0}>
      <div className="min-h-screen bg-neutral-50">
        <Sidebar />
        <div
          className={cn(
            'transition-all duration-300',
            isMobile ? 'ml-0' : isCollapsed ? 'ml-16' : 'ml-64'
          )}
        >
          <Header />
          {currentPhase && (
            <div className="sticky top-16 z-20 px-3 lg:px-8 pt-3 pb-0 bg-neutral-50 overflow-x-auto">
              <PhaseFlow
                phases={PHASES}
                currentPhase={currentPhase}
                size="compact"
              />
            </div>
          )}
          <main className="p-3 lg:p-8">
            <Outlet />
          </main>
        </div>
        <AIChatBubble />
      </div>
    </TooltipProvider>
  )
}
